import CryptoJS from "crypto-js"; // AES加密库
import JSEncrypt from "jsencrypt"; // RSA加密库

// 初始化RSA
const rsa = new JSEncrypt();
rsa.setPublicKey(`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvLjXEkzEP/ggPyepVSdS
XKDo8UDcub4GtfQu0ghGHiN7Y//4r+KfnrmY6uoTZlrNIMkwPb2Jb+jYyD+A98h5
qs/6CK8hKOqPawgK0+kNecnr8Ngdka8GM5X4PA8A6MzTd5w9nK79z3jsD04WmxHA
w4yOFfMQP2m5gVts6XmFzIPZSz7r4M1BXYlKOV6Z++icPMj356eu8BaBQBQwm/ps
AomKhb2U5eXjURM6+flWcDttcgPMNjtSGPOmfZPpmNxZHnp8cpdzd5aSWwyTBZ8o
zQTKDSet1jcF/twHt0N6xXa8oo3emRbrI67smkZrhO8A2kRM91o6C1pCqyu6oU+p
7QIDAQAB
-----END PUBLIC KEY-----`);

// AES加密函数
function aesEncrypt(data, key) {
  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  // console.log("密文", encrypted.toString());
  return encrypted.toString(); // 返回Base64格式的加密数据
}

//AES解密(后端用)
function aesDecryptData(data, key) {
  const decryptedData = CryptoJS.AES.decrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
  return decryptedText;
}

// RSA加密函数
function rsaEncrypt(aesKey) {
  return rsa.encrypt(aesKey); // 返回RSA加密后的AES密钥
}

// 获取随机AES密钥
function generateAesKey() {
  return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
}

// RSA解密函数（后端用）
function rsaDecrypt(data) {
  const decrypted = rsa.decrypt(data); // 使用私钥解密数据
  return decrypted;
}

export default {
  aesEncrypt,
  rsaEncrypt,
  generateAesKey,
  rsaDecrypt,
  aesDecryptData,
};
